import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber2 = () => {
  return (
    <g>
      <path d="m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm2.8063 11.6314h-5.3955v-1.0585c2.1972-1.6797 3.7617-2.7608 3.7617-4.2569a1.1908 1.1908 0 0 0 -1.2425-1.3457 1.1447 1.1447 0 0 0 -1.1852 1.2188 1.3668 1.3668 0 0 0 .23.748l-1.1963.4834a2.0961 2.0961 0 0 1 -.3916-1.3115 2.3853 2.3853 0 0 1 2.5893-2.3009 2.3743 2.3743 0 0 1 2.623 2.4736c0 1.7715-1.875 3.2207-3.2441 4.1182h3.4512z" />
    </g>
  );
};

export default withIcon(IconNumber2);
